import { ITimelineItem, Timeline, Typography } from "@cpj-ai/panel-npm-package";
import { Card } from "@heroui/react";
import dayjs from "dayjs";
import React from "react";
import { IHiringProcessTabContentProps } from "./types";
import { getStatusConfig } from "./utils";

const HiringProcessCard: React.FC<IHiringProcessTabContentProps> = ({ statusHistories = [] }) => {
  const hiringTimelineItems: ITimelineItem[] = statusHistories
    .map((history, index) => {
      if (!history) return null;

      const isLastStatus = index === statusHistories.length - 1;
      const formattedDate = dayjs(history.createdAt).format("MM/DD/YYYY - HH:mm") || "-";
      const statusConfig = getStatusConfig(history, isLastStatus);

      return {
        title: statusConfig.title,
        date: formattedDate,
        content: statusConfig.content,
        status: statusConfig.status,
        icon: statusConfig.icon,
      };
    })
    .filter((item) => item !== null);

  return (
    <Card className="p-4 flex flex-col gap-8 w-full">
      <Typography variant="h4">Hiring Process:</Typography>
      {hiringTimelineItems.length ? (
        <Timeline items={hiringTimelineItems} direction="asc" />
      ) : (
        <p className="text-xl text-center my-20">Hiring process not started</p>
      )}
    </Card>
  );
};

export default HiringProcessCard;
